export const global = $state({
	data: {},
	showSelectedApp: false,
	selectedAppData: null,
	notification: null
});
